import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AuxiliaryDataModule } from '../../auxiliary-data.module';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { ObjectType } from '../schema-service/schema-interface';
import { AuxiliaryFieldHandlerService, LoadingStatus } from '../auxiliary-field-handler.service';
import { Observable, Subject, debounceTime, map, shareReplay, switchMap, take, takeUntil } from 'rxjs';
import { FieldHandler } from '../auxiliary-data-table/auxiliary-data-table.interface';
import { AsyncPipe } from '@angular/common';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Component({
  selector: 'aux-auxiliary-data-fields-responsive',
  templateUrl: './auxiliary-data-fields-responsive.component.html',
  styleUrl: './auxiliary-data-fields-responsive.component.scss',
  imports: [AuxiliaryDataModule, ReactiveFormsModule, FormsModule, AsyncPipe],
})
export class AuxiliaryDataFieldsResponsiveComponent implements OnInit, OnDestroy {
  @Input() objectId: string;
  @Input() partnerId: string;
  @Input() objectType: ObjectType;
  @Output() valuesChanged: EventEmitter<{ [key: string]: any }> = new EventEmitter();

  formGroup = new UntypedFormGroup({});
  loadingStatus$ = this.auxiliaryDataService.loadingStatus$;
  LoadingStatus = LoadingStatus;
  destroyed$$ = new Subject<void>();

  fieldHandlers$!: Observable<FieldHandler[]>;

  constructor(
    private auxiliaryDataService: AuxiliaryFieldHandlerService,
    private snackbar: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.initialize();
  }

  private initialize(): void {
    const showLabel = true;
    this.auxiliaryDataService.init(this.partnerId, this.objectType, this.objectId, showLabel);
    this.fieldHandlers$ = this.auxiliaryDataService.fieldHandlers$.pipe(shareReplay({ refCount: true, bufferSize: 1 }));
    this.fieldHandlers$.pipe(takeUntil(this.destroyed$$)).subscribe((handlers) => {
      handlers.forEach((handler) => {
        this.formGroup.setControl(handler.fieldId, handler.formControl, { emitEvent: false });
      });
    });
    this.formGroup.valueChanges
      .pipe(
        debounceTime(500),
        takeUntil(this.destroyed$$),
        switchMap((formValue) =>
          this.auxiliaryDataService.saveChanges().pipe(
            take(1),
            map((madeUpdates) => [madeUpdates, formValue]),
          ),
        ),
      )
      .subscribe({
        next: ([madeUpdates, formValue]) => {
          if (madeUpdates) {
            this.snackbar.openSuccessSnack('AUXILIARY_DATA_CARD.SAVE.SUCESS');
            this.valuesChanged.emit(formValue);
          }
        },
        error: () => this.snackbar.openErrorSnack('AUXILIARY_DATA_CARD.SAVE.ERROR'),
      });
  }

  reload(): void {
    this.initialize();
  }

  ngOnDestroy(): void {
    this.destroyed$$.next();
    this.destroyed$$.unsubscribe();
  }
}
